/**
 * זיהוי רשת חלשה / חיסכון בנתונים — לסניפים עם קליטה גרועה.
 * כשזה true: מעדיפים מטמון מקומי ולא מפעילים סנכרוני רקע כבדים.
 */

export function isOnline() {
  return typeof navigator === "undefined" ? true : navigator.onLine !== false;
}

export function isSlowOrDataSaverConnection() {
  if (typeof navigator === "undefined") return false;
  if (!navigator.onLine) return true;
  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn?.saveData) return true;
  const type = String(conn?.effectiveType || "").toLowerCase();
  return type === "2g" || type === "slow-2g" || type === "3g";
}

/** רשת גרועה מספיק כדי לא לגנוב bandwidth מניווט/סל */
export function shouldPreferLocalData() {
  return !isOnline() || isSlowOrDataSaverConnection();
}

/**
 * ברירות מחדל ל־React Query במסכי סניף — פחות רענונים אגרסיביים ב־3G.
 * @param {{ staleTimeFast?: number, staleTimeSlow?: number }} [opts]
 */
export function branchQueryOptions(opts = {}) {
  const preferLocal = shouldPreferLocalData();
  const staleTimeFast = opts.staleTimeFast ?? 5 * 60 * 1000;
  const staleTimeSlow = opts.staleTimeSlow ?? 30 * 60 * 1000;
  return {
    networkMode: "offlineFirst",
    staleTime: preferLocal ? staleTimeSlow : staleTimeFast,
    refetchOnWindowFocus: !preferLocal,
    refetchOnReconnect: true,
    retry: preferLocal ? 0 : 1,
  };
}

/** מרווח פולינג להתראות — ב־3G לא כל 8 שנ׳ */
export function notificationPollIntervalMs() {
  if (!isOnline()) return false;
  if (isSlowOrDataSaverConnection()) return 90_000;
  return 15_000;
}
